import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgLinkOut(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.9819 5.25025L20 5.25024V2.75024L28 2.75025C28.6904 2.75025 29.25 3.30989 29.25 4.00025V12.0002H26.75V7.01772L15.884 17.884L14.1162 16.1162L24.9819 5.25025Z"
      />
      <path
        fill="currentColor"
        d="M2.75 7C2.75 6.30964 3.30964 5.75 4 5.75H12V8.25H5.25V26.7504H23.75V20.0001H26.25V28.0004C26.25 28.6907 25.6904 29.2504 25 29.2504H4C3.30964 29.2504 2.75 28.6907 2.75 28.0004V7Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLinkOut);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
